import Sentry from "./sentry.import";
import getUserName from "../utils/getUserName";

export const setUserContext = () => {
  Sentry.setUser({ email: getUserName() });
};
